import React from "react";
import Alert from "react-bootstrap/Alert";

interface AlertMessageProps {
  show: boolean;
  message: string;
  variant: "success" | "danger" | "info" | "warning";
  onClose: () => void;
}

/**
 * Component for displaying alert messages in PM Grading
 */
const AlertMessage: React.FC<AlertMessageProps> = ({
  show,
  message,
  variant,
  onClose,
}) => {
  if (!show) return null;

  return (
    <Alert variant={variant} dismissible onClose={onClose} className="mb-4">
      {message}
    </Alert>
  );
};

export default AlertMessage;
